export const cardHeartOffIconFor4 = 'https://cf.res.s.zigzag.kr/zds/product_card_heart_off_icon.png';
export const cardHeartOnIconFor4 = 'https://cf.res.s.zigzag.kr/zds/product_card_heart_on_icon.png';
export const productCardReviewLightIcon = 'https://cf.res.s.zigzag.kr/zds/product_card_review_light_icon.png';
export const productCardReviewDarkIcon = 'https://cf.res.s.zigzag.kr/zds/product_card_review_dark_icon.png';

export const fastShipDeliveryIcon =
  'https://cf.image-farm.s.zigzag.kr/original/cms/2024/03/19/202403190248195634_044489.svg';
